import React, { useState } from 'react';
import './DisplayBoard.css';

function DisplayBoard({ tickets, totalTickets, onNewRequest, onTicketClick, onModalClose }) {
  // State pro výběr požadavku
  const [selectedRequest, setSelectedRequest] = useState('');
  const [customRequest, setCustomRequest] = useState('');

  const predefinedRequests = [
    'Chci, aby pro stát pracovali odborníci, ne kamarádi a známí politiků',
    'Chci, aby veřejné zakázky vyhrávala nejvyšší kvalita nakoupené služby, ne sponzoři vítězů voleb',
    'Chci dostat důchod včas, ne až za půl roku',
    'Chci, aby vzdělávání našich dětí řídili experti, ne loutky politických stran',
    'Chci, aby Česká republika prosperovala, ne aby dělala kroky zpět'
  ];

  const handleSubmit = () => {
    const request = selectedRequest === 'custom' ? customRequest : selectedRequest;
    if (request && request.trim()) {
      onNewRequest(request);
      // Vyčistit formulář po odeslání
      setSelectedRequest('');
      setCustomRequest('');
    }
  };

  return (
    <div className="display-board">
      <header className="board-header">
        <div className="header-logo">
          <img
            src="/assets/images/czech_flag.svg"
            alt="Česká vlajka"
            className="czech-flag"
          />
          <h1>NECHCEME STÁT VE FRONTĚ</h1>
        </div>
      </header>

      <div className="board-content">
        {/* Úvodní text */}
        <div className="intro-text">
          <div className="intro-header">
            <h2>Stát má sloužit lidem, ne politikům!</h2>
          </div>
          <div className="intro-body">
            <p>
              Ve Sněmovně se právě schvaluje zákon o státních zaměstnancích. Pokud projde v navrhované podobě, čekají nás přetížené úřady a neodborná rozhodnutí. A na to doplatíme my občané. Pokud státní správu ovládnou politici, budeme všichni stát v nekonečných frontách!
            </p>
            <h3>Vyzkoušejte si, jak to bude na úřadech vypadat:</h3>
            <ul>
              <li>vyberte si požadavek</li>
              <li>vygenerujte pořadové číslo</li>
              <li>sdílejte ho na sociálních sítích s tím, že se obáváte o budoucnost českého státu</li>
            </ul>
          </div>
          <div className="intro-footer">
            <p>Snad na Vás někdy přijde řada.</p>
          </div>
        </div>

        {/* Sekce výběru požadavku */}
        <div className="main-display">
          <div className="display-header">
            <div className="display-title">CO POTŘEBUJI OD STÁTU</div>
          </div>

          <div className="request-selection">
            {predefinedRequests.map((request, index) => (
              <label key={index} className="request-option">
                <input
                  type="radio"
                  name="request"
                  value={request}
                  checked={selectedRequest === request}
                  onChange={(e) => {
                    setSelectedRequest(e.target.value);
                    setCustomRequest('');
                  }}
                />
                <span className="request-text">{request}</span>
              </label>
            ))}

            <label className="request-option custom-option" style={{ minHeight: '80px', alignItems: 'flex-start' }}>
              <input
                type="radio"
                name="request"
                value="custom"
                checked={selectedRequest === 'custom'}
                onChange={(e) => setSelectedRequest(e.target.value)}
                style={{ marginTop: '8px' }}
              />
              <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                <input
                  type="text"
                  className="custom-request-input"
                  placeholder="Chci..."
                  value={customRequest}
                  maxLength={160}
                  onChange={(e) => {
                    setCustomRequest(e.target.value);
                    setSelectedRequest('custom');
                  }}
                  onFocus={() => setSelectedRequest('custom')}
                />
                <div style={{
                  fontSize: '12px',
                  color: customRequest.length >= 160 ? '#d9534f' : '#666',
                  marginTop: '4px',
                  textAlign: 'right',
                  minHeight: '18px'
                }}>
                  {customRequest.length}/160 znaků {customRequest.length >= 160 && '(dosažen limit)'}
                </div>
              </div>
            </label>
          </div>

          <button
            className="new-request-btn"
            onClick={handleSubmit}
            disabled={!selectedRequest || (selectedRequest === 'custom' && !customRequest.trim())}
          >
            <span className="btn-icon">🎫</span>
            VYZVEDNOUT NOVÝ LÍSTEK
          </button>

          <div className="display-info">
            <div className="info-item">
              <span className="info-label">ČEKAJÍCÍCH:</span>
              <span className="info-value">{totalTickets}</span>
            </div>
            <div className="info-item">
              <span className="info-label">PRŮMĚRNÁ DOBA:</span>
              <span className="info-value">7-9 LET</span>
            </div>
          </div>
        </div>

        {/* Přehled všech vydaných lístků */}
        {tickets.length > 0 && (
          <div className="tickets-overview">
            <div className="overview-title">NEDÁVNO VYDANÉ LÍSTKY</div>
            <div className="tickets-grid">
              {tickets.map((ticket) => (
                <div
                  key={ticket.id}
                  className="ticket-card"
                  onClick={() => onTicketClick(ticket)}
                >
                  <div className="ticket-number">#{ticket.ticket_number}</div>
                  <div className="ticket-request">
                    {ticket.request}
                  </div>
                  <div className="ticket-year">
                    Očekáváno: <strong>{ticket.expected_year}</strong>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        <footer className="board-footer">
          <div className="footer-content">
            <p>Děkujeme za trpělivost. Vaše žádost je pro nás prioritou.*</p>
            <p className="disclaimer">* Prioritou číslo {Math.floor(Math.random() * 10000) + 1000}</p>
          </div>

          <div className="footer-logos">
            <a
              href="https://www.ochranademokracie.cz/aktuality/hrozi-demontaz-statni-spravy-zatahneme-zachrannou-brzdu"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-logo-link"
            >
              <img
                src="/assets/images/SkOD_modre.svg"
                alt="Spolek k ochraně demokracie"
                className="footer-logo"
              />
            </a>
            <a
              href="https://www.ceskofunguj.cz"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-logo-link"
            >
              <img
                src="/assets/images/cesko_funguj_horizont_fialove.png"
                alt="Česko funguj"
                className="footer-logo"
              />
            </a>
          </div>
        </footer>
      </div>
    </div>
  );
}

export default DisplayBoard;
